import * as t from 'io-ts';
import { OktmoCode, OktmoCodeType } from './oktmoCode';
import { OktmoMin, OktmoMinType } from './oktmoMin';

export const OktmoType = t.interface({
    id: t.string,
    name: t.union([t.string, t.null, t.undefined]),
    fullName: t.union([t.string, t.null, t.undefined]),
    code: t.union([OktmoCodeType, t.null, t.undefined]),
    description: t.union([t.string, t.null, t.undefined]),
    municipality: t.union([OktmoMinType, t.null, t.undefined]),
    additionalInformation: t.union([t.string, t.null, t.undefined]),
    settlementMunicipality: t.union([OktmoMinType, t.null, t.undefined]),
});

export interface OktmoDTO extends t.TypeOf<typeof OktmoType> {}

class Oktmo {
    id: string;
    name: string | null;
    code: OktmoCode | null;
    fullName: string | null;
    description: string | null;
    municipality: OktmoMin | null;
    additionalInformation: string | null;
    settlementMunicipality: OktmoMin | null;

    constructor(params: OktmoDTO) {
        this.id = params.id;
        this.code = !!params.code
            ? new OktmoCode(params.code)
            : null;
        this.name = params.name ?? null;
        this.fullName = params.fullName ?? null;
        this.municipality = !!params.municipality
            ? new OktmoMin(params.municipality)
            : null;
        this.description = params.description ?? null;
        this.settlementMunicipality = !!params.settlementMunicipality
            ? new OktmoMin(params.settlementMunicipality)
            : null;
        this.additionalInformation = params.additionalInformation ?? null;
    }
}

export { Oktmo };
